//import axios, { CancelTokenSource } from 'axios';
import React from 'react';
import { RouteComponentProps } from 'react-router';
import { withRouter } from 'react-router-dom';
import FormText from '../../components/forms/formText/FormText';
import Button from '../../components/forms/button/Button';

import json2yaml from '../../services/json2yaml';

import { personsSearch, messagesSearch, attachmentsSearch } from '../../services/search';

export interface IRouterParams {
}

type Props = RouteComponentProps<IRouterParams>;

interface IOwnState {
    personContent: string,
    messageContent: string,
    attachmentContent: string,
    searchText: string,
    isloading: boolean;
}

class Search extends React.Component<Props, IOwnState> {
    constructor(props: Props) {
        super(props);

        this.state = {
            personContent: '',
            messageContent: '',
            attachmentContent: '',
            searchText: '',
            isloading: false
        }
    }

     public render() {
        return <React.Fragment>
            
            <section className="section">
                <div className="deck">
                    <div className="w--md banner-title">
                        <h1>Søgning</h1>
                    </div>
                </div>
                <div className="deck">
                    <div className="w--md">
                        <form onSubmit={this.handleClick}>
                        <div className="flex-grid">
                            <div className="flex-grid__col flex-grid__col--12 flex-grid__col--sm-4 ">
                                <div className="form">
                                    <div className="form__section">
                                        <FormText name="searchText" label="Søgetekst" initialValue={this.state.searchText} onChange={this.handleSearchTextChange} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br />
                        <Button modifierClass="button--small button--primary" type="submit" onClick={this.handleClick} disabled={this.state.isloading} spinning={this.state.isloading}>Søg</Button>
                        </form>
                        <br /><br />
                        <hr />

                        <br />

                        {(!this.state.isloading) &&
                            <React.Fragment>
                            {this.state.personContent &&
                                <React.Fragment>
                                <h2 className="contact__headline">Person resultater:</h2>
                                <pre>{ this.state.personContent}</pre> <br />
                                </React.Fragment>
                            }
                            {this.state.messageContent &&
                                <React.Fragment>
                                <h2 className="contact__headline">Besked resultater:</h2>
                                    <pre>{this.state.messageContent}</pre> <br />
                                </React.Fragment>
                            }
                            {this.state.attachmentContent &&
                                <React.Fragment>
                                <h2 className="contact__headline">Dokument resultater:</h2>
                                    <pre>{this.state.attachmentContent}</pre>
                                </React.Fragment>
                            }
                        </React.Fragment>
                        }
                    </div>
                </div>
            </section>
        </React.Fragment>;
    }

    private handleSearchTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ searchText: e.target.value });
    }

    private handleClick = async () => {

        this.setState({ isloading: true });

        var persons = [];
        var messages = [];
        var attachments = [];

        try {
            persons = await personsSearch(this.state.searchText);
        } catch (e) {
            console.log(e);
        }
        try {
            messages = await messagesSearch(this.state.searchText);
        } catch (e) {
            console.log(e);
        }
        
        try {
            attachments = await attachmentsSearch(this.state.searchText);
        } catch (e) {
            console.log(e);
        }
        
        this.setState({
            personContent: json2yaml(persons).replace(/- document: /g, '\n- document: '),
            messageContent: json2yaml(messages).replace(/- document: /g, '\n- document: '),
            attachmentContent: json2yaml(attachments).replace(/- document: /g, '\n- document: '),
            isloading: false
        });
    }
}

export default withRouter(Search);